module.exports = __webpack_public_path__ + "static/media/monterreyimg.7584f6d2.jpg";